export default __webpack_public_path__ + "static/media/agendar-post.538a4705.svg";